import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Header from './Header'
import Menu from './Menu'
import { Outlet, useNavigate } from 'react-router-dom'
import { metodoPrograma, notificacao } from '../components/api'
import { GlobalContext } from '../App'
import { ModalAgendaSelected } from '../ModalAgendaSelected'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
    height: '100%',
    backgroundColor: '#e7e8e8',
  },
}))

const Interface = () => {
  const { dispatch, localAtendimento, verificaLogin } =
    useContext(GlobalContext)

  const navigate = useNavigate()

  const buscaNotificacoes = async () => {
    const { lista } = await notificacao()
    dispatch({ field: 'notificacoes', value: lista })
  }

  const [listaLocalAtendimento, setListaLocalAtendimento] = useState([])
  const [noLocalMessage, setNoLocalMessage] = useState('')

  const buscarListaLocalAtendimento = useCallback(() => {
    metodoPrograma('listaLocalAtendimento', {}, 'CtrlAgendamento').then(
      (res) => {
        if (res.status) {
          setListaLocalAtendimento(res.lista)
          if (res.lista.length === 1 && !res.lista[0][3]) {
            dispatch({ type: 'setLocalAtendimento', value: res.lista[0] })
          } else {
            setNoLocalMessage(
              res.lista.length === 0
                ? 'Nenhum local de atendimento cadastrado.'
                : '',
            )
          }
        }
      },
    )
  }, [dispatch])

  useEffect(() => {
    verificaLogin(null, navigate, location)
    const localAtendimento = localStorage.getItem('selectedLocalAtendimento')

    if (localAtendimento) {
      dispatch({
        type: 'setLocalAtendimento',
        value: JSON.parse(localAtendimento),
      })
    }
    buscarListaLocalAtendimento()
    buscaNotificacoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Header />
      <Menu />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Outlet />
      </main>
      <ModalAgendaSelected />
      <Dialog
        open={location.pathname !== '/login' && localAtendimento === null}
      >
        <DialogTitle>Selecione o local de atendimento</DialogTitle>
        <DialogContent>
          {noLocalMessage && (
            <Typography color="error">{noLocalMessage}</Typography>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              padding: '10px',
            }}
          >
            {listaLocalAtendimento.map((local) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px',
                  border: '1px solid gray',
                  borderRadius: '7px',
                  cursor: 'pointer',
                }}
                key={local[0]}
                onClick={() =>
                  dispatch({ type: 'setLocalAtendimento', value: local })
                }
              >
                {local[1]}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Interface
